import React, { useState, useEffect } from "react";
import "./style.css";

const CountDown = () => {
  const [isExpired, setIsExpired] = useState(false);
  const [days,    setDays]    = useState(0);
  const [hours,   setHours]   = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const countDownDate = new Date("2026-09-19T22:17:00").getTime();
    const x = setInterval(() => {
      const now      = new Date().getTime();
      const distance = countDownDate - now;

      const day    = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hour   = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minute = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const second = Math.floor((distance % (1000 * 60)) / 1000);

      if (days    !== day)    setDays(day);
      if (hours   !== hour)   setHours(hour);
      if (minutes !== minute) setMinutes(minute);
      if (seconds !== second) setSeconds(second);

      if (distance < 0) {
        clearInterval(x);
        setIsExpired(true);
      }
    }, 1000);

    return () => clearInterval(x);
  }, [days, hours, minutes, seconds]);

  if (isExpired) {
    return <div className="std-cd-today">¡Es Hoy!</div>;
  }

  const units = [
    { value: days,    label: "Días" },
    { value: hours,   label: "Horas" },
    { value: minutes, label: "Min" },
    { value: seconds, label: "Seg" },
  ];

  return (
    <div className="std-cd-clock">
      {units.map((unit, i) => (
        <React.Fragment key={unit.label}>
          <div className="std-cd-unit">
            <span className="std-cd-number">{String(unit.value).padStart(2, "0")}</span>
            <span className="std-cd-label">{unit.label}</span>
          </div>
          {i < units.length - 1 && <span className="std-cd-sep">·</span>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default CountDown;
